import { Button, Dropdown, Modal } from 'react-bootstrap'
import logoImage from '../images/logo192.png'
import { signOut } from 'firebase/auth';
import { useEffect, useState } from 'react';
import { auth, db } from '../services/Firebase';
import { collection, doc, getDoc, getDocs, orderBy, query } from 'firebase/firestore';
import { useAuth } from '../hooks/AuthContext';
import { formatDate, formatTime } from '../utils/FormatDateTime';
import { useNavigate } from 'react-router-dom';
import { Trans, useTranslation } from 'react-i18next';
import LanguageSelector from './LanguageSelector';

export default function ProfilePage() {
    const { authUser } = useAuth()
    const [showLogoutDialog, setShowLogoutDialog] = useState(false)
    const [summaryList, setSummaryList] = useState([])
    const [userData, setUserData] = useState({})
    const [loading, setLoading] = useState(true)
    const navigate = useNavigate()
    const { t } = useTranslation()

    useEffect(() => {
        if (authUser) {
            fetchProfileData();
            fetchUserData()
        }
    }, []);



    const fetchProfileData = async () => {
        try {
            const summariesRef = collection(db, "users", authUser.uid, "summaries")
            const sorting = query(summariesRef, orderBy("createdAt", "desc"));

            const querySnapshot = await getDocs(sorting)

            const summaries = querySnapshot.docs.map((doc) => ({
                id: doc.id,
                ...doc.data()
            }))
            setSummaryList(summaries)
            setLoading(false)
        } catch (error) {
            setLoading(false)
            console.log(error)
        }
    }

    const fetchUserData = async () => {
        try {
            const userDataRef = doc(db, "users", authUser.uid)
            const snapshot = await getDoc(userDataRef)

            if (snapshot.exists()) {
                setUserData({ id: snapshot.id, ...snapshot.data() })
            }
        } catch (error) {
            setLoading(false)
            console.log(error)
        }
    }

    const goToSearchPage = () => {
        navigate('/')
    }

    function onLogoutClick() {
        setShowLogoutDialog(true);
    }

    function cancelLogout() {
        setShowLogoutDialog(false);
    };

    function confirmLogout() {
        setShowLogoutDialog(false);
        signOut(auth)
    };
    return (
        <div className="profile-page">
            <div className="header-container">
                <div onClick={goToSearchPage} className='header-left'>
                    <img src={logoImage} alt="Logo" className="logo" />
                    <h3>Sigurica AI</h3>
                </div>
                <div className='header-right'>
                    <Button onClick={() => onLogoutClick()} className='button-logout'><i class="bi bi-box-arrow-in-left"></i>{t('logoutAction')}</Button>
                </div>
            </div>

            <div className="profile-container">
                <div className="content-wrapper">

                    <div>
                        <div className="profile-left-card">
                            <div className="banner"></div>
                            <div className="profile-avatar">
                                <i class="bi bi-person-fill"></i>
                            </div>
                            <div className="profile-info">
                                <p className='profile-info-full-name'>{userData.fullName}</p>
                                <p className='role'>{authUser.email}</p>
                                <p className='role mb-2'>{t('userSince')} {formatDate(authUser.metadata.creationTime)}</p>
                                <LanguageSelector />

                                {/* <div className="buttons">
                                    <button className="more-btn">More</button>
                                </div> */}
                            </div>
                        </div>
                    </div>

                    <div className="profile-right-card">
                        <h3>{t('savedMatches')}</h3>
                        {loading ? (
                            <div className="spinner-wrapper">
                                <div className="spinner-border spinner-border-sm-custom" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                            </div>
                        ) : summaryList.length === 0 ? (
                            <p>{t('noSavedMatches')}</p>
                        ) : (
                            <div className="profile-matches-grid">
                                {summaryList.map((summary, index) => (
                                    <div className="match-card-profile"
                                        key={summary.id}
                                        onClick={() => navigate(`/match/${summary.id}`)}
                                    >
                                        <div className="match-teams-row">
                                            <div className="team-column-profile">
                                                <span>{summary.homeTeamName}</span>
                                            </div>
                                            <div className="vs">:</div>
                                            <div className="team-column-profile">
                                                <span>{summary.awayTeamName}</span>
                                            </div>
                                        </div>
                                        <div className="match-info-profile">
                                            <span>{formatDate(summary.date)} • {formatTime(summary.date)}h</span>
                                            <span className="league">{summary.leagueName}</span>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                </div>
            </div>

            <Modal show={showLogoutDialog} onHide={cancelLogout} centered>
                <Modal.Header style={{ borderBottom: 'none' }} closeButton>
                    <Modal.Title>{t('logout')}</Modal.Title>
                </Modal.Header>
                <Modal.Body className='text-center'>{t('confirmLogout')}</Modal.Body>
                <Modal.Footer className="d-flex justify-content-between" style={{ borderTop: 'none' }}>
                    <Button variant="secondary" onClick={cancelLogout} className="w-25 noButtonModal">{t('no')}</Button>
                    <Button variant="primary" onClick={confirmLogout} className="w-25 yesButtonModal">{t('yes')}</Button>
                </Modal.Footer>
            </Modal>
        </div>
    )
}